export default __webpack_public_path__ + "static/media/Ms. Lopamudra Behera.4fd174fb.png";